import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'

import {
  isAxiosClientErrorRejection,
  isCancelledRequestError,
  isContentlessRejection,
  isDOMMutationError,
  isDynamicLoadError,
  isInAppBrowserError,
  isMediaDeviceError,
  isResizeObserverError,
  isThirdPartyError,
} from '@shared/utils'

const config = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_BUILD_ENV,
  revision: import.meta.env.VITE_GIT_HASH,
  maxErrors: 30,
  // Ignore errors from local
  developmentEnvironments: ['local'],
}

export const honeybadger = Honeybadger.configure(config).beforeNotify((notice) => {
  if (isDynamicLoadError(notice)) return false
  if (isInAppBrowserError(notice)) return false
  if (isThirdPartyError(notice)) return false
  if (isResizeObserverError(notice)) return false
  if (isMediaDeviceError(notice)) return false
  if (isAxiosClientErrorRejection(notice)) return false
  if (isCancelledRequestError(notice)) return false
  if (isContentlessRejection(notice)) return false
  if (isDOMMutationError(notice)) {
    notice.name = 'GoogleTranslateError'
    notice.message = notice.url
  }
  return true
})

window.honeybadger = honeybadger

// Leaving as it is if we would like some common intercepting logic here
export default function HoneybadgerProvider({ children }) {
  return <HoneybadgerErrorBoundary honeybadger={honeybadger}>{children}</HoneybadgerErrorBoundary>
}
